import Search from "./search"

export default function SearchBar() {
  return (
    <div className="searchBox">
      <Search />
    </div>
  )
}
